import React from 'react';
import {format, percent} from './data';

const direction = value => value > 0 ? 'up' : value < 0 ? 'down' : '';

export default function DailyBriefing({briefing, onStock}) {
  if (!briefing) return null;
  const absoluteMax = Math.max(...briefing.sectors.map(row => Math.abs(row.change_1d)), 1);
  return <section className="daily-briefing" aria-labelledby="daily-briefing-title">
    <div className="briefing-header">
      <div><span className="eyebrow">TODAY'S RESEARCH BRIEF</span><h2 id="daily-briefing-title">뉴스와 시장 관측을 분리해 읽기</h2></div>
      <p>{briefing.as_of?.slice(0, 10)} 장 마감 기준 · MTA 표본 {format(briefing.sample_size, 0)}개</p>
    </div>
    <div className="briefing-grid">
      <article className="briefing-panel breadth-panel">
        <span>표본 내 시장 폭</span>
        <div className="breadth-numbers"><b className="up">{briefing.breadth.up}</b><i>/</i><b className="down">{briefing.breadth.down}</b></div>
        <p>상승 / 하락 종목 수</p>
        <div className="breadth-track"><i style={{width:`${briefing.breadth.up/(briefing.breadth.up+briefing.breadth.down)*100}%`}} /></div>
        <small>전체 시장 지수나 전체 상장 종목의 비율이 아닙니다.</small>
      </article>
      <article className="briefing-panel sector-panel">
        <span>표본 내 업종 평균 등락</span>
        <div className="sector-bars">{briefing.sectors.map(row => <div key={row.name}><label>{row.name}<small>{row.count}개</small></label><div className="sector-track"><i className={direction(row.change_1d)} style={{width:`${Math.abs(row.change_1d)/absoluteMax*100}%`}} /></div><b className={direction(row.change_1d)}>{percent(row.change_1d)}</b></div>)}</div>
      </article>
      <article className="briefing-panel leader-panel">
        <span>MTA 점수 상위 관측 종목</span>
        {briefing.leaders.map(stock => <button key={stock.code} onClick={() => onStock?.(stock.code)}><span>{stock.name}<small>{stock.code} · {stock.sector}</small></span><b>{format(stock.score)}<small> /100</small></b><i className={direction(stock.change_1d)}>{percent(stock.change_1d)}</i></button>)}
        <p>MTA 점수는 실험 중인 탐색 지표입니다.</p>
      </article>
    </div>
    <div className="news-context"><div><span className="eyebrow">SOURCE-CHECKED NEWS CONTEXT</span><h3>원문 메타데이터를 확인한 읽을거리</h3><p>아래 뉴스는 원문 페이지의 제목·링크를 확인했습니다. 텔레그램 요약이나 시장 반응의 정확성을 보증하지 않습니다.</p></div><div className="news-list">{briefing.news.map(item => <article key={item.source_url}><div><span>{item.topics.join(' · ')}</span><h4>{item.headline}</h4><p>{item.source_title}</p></div><div className="news-links"><a href={item.source_url} target="_blank" rel="noreferrer">원문 ↗</a><a href={item.telegram_url} target="_blank" rel="noreferrer">관측 출처 ↗</a></div>{item.mta_context?.length>0&&<small>MTA 대조: {item.mta_context.map(s => `${s.name} ${percent(s.change_1d)} (${s.data_date})`).join(' · ')}</small>}</article>)}</div></div>
    <p className="briefing-footnote">{briefing.method_note}</p>
  </section>;
}
